import React from 'react';

/**
 * TalkNote logosu: sol altta kuyruklu mavi konuşma balonu, içinde beyaz halka
 * (desktop/build/icon.svg ve tanıtım sitesindeki #i-mark ile aynı çizim).
 * `animated`: Hazırsın ekranındaki hoş geldin animasyonu — balon büyüyerek
 * gelir, halka çizilir (index.css › brand-pop, brand-ring).
 */
export const BrandMark: React.FC<{ className?: string; animated?: boolean; title?: string }> = ({
  className,
  animated = false,
  title,
}) => (
  <svg
    viewBox="114 66 161 161"
    className={className}
    role={title ? 'img' : undefined}
    aria-label={title}
    aria-hidden={title ? undefined : true}
  >
    <path
      className={animated ? 'brand-pop' : undefined}
      fill="#519cf9"
      d="M157.4 213.9A78 78 0 1 0 131.7 191.9L119.6 220.5Q117.8 227 124.2 225.3Z"
    />
    <circle
      className={animated ? 'brand-ring' : undefined}
      cx="194"
      cy="145"
      r="33"
      fill="none"
      stroke="#fff"
      strokeWidth="17"
      pathLength={100}
    />
  </svg>
);
